import firebase from 'firebase';

const firebaseConfig = {
    apiKey: "AIzaSyCrPYvfIgu8zGP3doxAYYzKnJqmo8OwcAo",
    authDomain: "snapchat-clone-38fbd.firebaseapp.com",
    projectId: "snapchat-clone-38fbd",
    storageBucket: "snapchat-clone-38fbd.appspot.com",
    messagingSenderId: "948912237522",
    appId: "1:948912237522:web:5fc5bf76fd91039044760b"
  };

  const firebaseApp = firebase.initializeApp(firebaseConfig);
  const db = firebaseApp.firestore();
  const auth = firebase.auth();
  const storage = firebase.storage();
  const provider = new firebase.auth.GoogleAuthProvider();

  export {db, auth, storage, provider};